import PropTypes from 'prop-types'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
  TableFooter
} from 'components/uikit-adapter/index'
import PaginationFooter from 'components/pagination/components/pagination-footer'
import TableRownColumnUnclickable from 'components/table-row-column-unclickable'
import IconButton from 'material-ui/IconButton'
import DeleteIcon from 'images/icn-trash-bin.svg'
import intl from 'react-intl-universal'
import { usesTmsIntegration } from 'utils/validations-general-settings'

const BusinessUnitiesList = ({
  data,
  countData,
  refreshSearch,
  handleEdit,
  qtRegsPerPage,
  handleDelete,
  profileAdminOrMasterData,
}) => {
  const canDelete = Boolean(profileAdminOrMasterData?.());
  const showTms = usesTmsIntegration();

  return (
    <Table
      fixedHeader
      fixedFooter
      multiSelectable={false}
      selectable={false}
      wrapperStyle={{ height: '100%' }}
      bodyStyle={{
        height: 'calc(100% - 110px)',
        borderTop: '1px solid rgb(224, 224, 224)',
        backgroundColor: 'var(--color-contrast-white)'
      }}
      onCellClick={handleEdit}
    >
      <TableHeader
        displaySelectAll={false}
        adjustForCheckbox={false}
        style={{ borderBottom: 'none' }}
      >
        <TableRow style={{ borderBottom: 'none' }}>
          <TableHeaderColumn className='table-header__column'>
            {intl.get('master-data.general-configuration.company')}
          </TableHeaderColumn>
          <TableHeaderColumn className='table-header__column'>
            {intl.get('master-data.general-configuration.center')}
          </TableHeaderColumn>
          <TableHeaderColumn>
            {intl.get('master-data.general-configuration.name')}
          </TableHeaderColumn>
          <TableHeaderColumn>
            {intl.get('master-data.general-configuration.supplierSAP')}
          </TableHeaderColumn>

          {showTms && (
            <TableHeaderColumn>
              {intl.get('master-data.general-configuration.codeTMS')}
            </TableHeaderColumn>
          )}

          <TableHeaderColumn>
            {intl.get('master-data.general-configuration.type')}
          </TableHeaderColumn>
          <TableHeaderColumn>Email</TableHeaderColumn>
          <TableHeaderColumn>Status</TableHeaderColumn>

          {canDelete && <TableHeaderColumn style={{ width: '100px' }} />}
        </TableRow>
      </TableHeader>

      <TableBody displayRowCheckbox={false} showRowHover>
        {data.map((v, i) => (
          <TableRow key={i} style={{ cursor: 'pointer' }}>
            <TableRowColumn>{v.Empresa}</TableRowColumn>
            <TableRowColumn>{v.Centro}</TableRowColumn>
            <TableRowColumn>{v.Nome}</TableRowColumn>
            <TableRowColumn>{v.FornecedorSap}</TableRowColumn>

            {showTms && <TableRowColumn>{v.CodigoTms}</TableRowColumn>}

            <TableRowColumn>{v.TipoUnidade}</TableRowColumn>
            <TableRowColumn>{v.Email ? v.Email.join('; ') : ''}</TableRowColumn>
            <TableRowColumn>{v.Status}</TableRowColumn>

            {canDelete && (
              <TableRownColumnUnclickable
                style={{ positon: 'relative', textAlign: 'right', width: '100px' }}
              >
                <div title={intl.get('master-data.managementUnity.unitys.actions.disabledBusinessUnit')}>
                  <IconButton onClick={() => handleDelete(v.Id)}>
                    <img src={DeleteIcon} alt='delete-icon' />
                  </IconButton>
                </div>
              </TableRownColumnUnclickable>
            )}
          </TableRow>
        ))}
      </TableBody>

      <TableFooter>
        <PaginationFooter
          countPerPage={qtRegsPerPage}
          countData={countData}
          refreshSearch={refreshSearch}
        />
      </TableFooter>
    </Table>
  );
};

BusinessUnitiesList.propTypes = {
  countData: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired, 
  handleEdit: PropTypes.func.isRequired,
  qtRegsPerPage: PropTypes.number.isRequired,
  refreshSearch: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  profileAdminOrMasterData: PropTypes.func.isRequired,
};

export default BusinessUnitiesList;
